import { isIP } from 'is-ip';

/**
 * Prevent app from loading if accessed via IP address (bots / IP scanners are doing this and causing spam to our RUM datadog logs otherwise).
 * Shows an error message and throws an error to stop execution.
 */
export const preventIPAccess = (): void => {
  const hostname = window.location.hostname;
  if (isIP(hostname)) {
    throw new Error('Access denied');
  }
};

export const urlFromLocalOrAbsolute = (
  pathOrUrl: string,
  protocol = window.location.protocol,
  hostname = window.location.hostname
) => {
  const isAbsolute = pathOrUrl.startsWith('http') || pathOrUrl.startsWith('ws');
  if (isAbsolute) {
    return pathOrUrl;
  }
  return `${protocol}//${hostname}${pathOrUrl}`;
};
